export default __webpack_public_path__ + "static/Edita_Prima_photo_bg_careers_page-28a0108631e75a43fa4eaf36b21e0816.jpg";